<mb-base-modal class="no-content-padding">
  <div class="content" dialog-content>
    <h2 class="headline h4">{{ 'EMBED_LIVESTREAM' | translate }}</h2>
    <div class="embed-code-container">
      <div class="code-container copy-l">
        <span class="mb-icon mb-icon-tag"></span>
        <input type="text" [disabled]="true" [value]="embedCode" />
      </div>
      <span class="btn" [cdkCopyToClipboard]="embedCode" (click)="copied = true">{{ 'COPY' | translate }}</span>
    </div>
    <div class="copied-container" [class.hidden]="!copied">
      <span class="mb-icon mb-icon-marked-ok"></span>
      {{ 'COPIED' | translate }}
    </div>
  </div>
</mb-base-modal>
